import { forwardRef } from 'react';
import TextField, { type TextFieldProps } from '@mui/material/TextField';
import { sanitizePersonName } from '../../../utils/personFieldValidation';

function isNameKey(key: string, ctrl: boolean): boolean {
  if (ctrl) return true;
  if (key.length !== 1) return true;
  return /[\p{L}\s]/u.test(key);
}

const PersonNameField = forwardRef<HTMLInputElement, TextFieldProps>(function PersonNameField(
  { onChange, onKeyDown, inputRef, inputProps, ...props },
  ref,
) {
  return (
    <TextField
      {...props}
      inputRef={inputRef || ref}
      inputProps={{
        autoComplete: 'off',
        spellCheck: false,
        inputMode: 'text',
        pattern: '[\\p{L} ]*',
        ...inputProps,
      }}
      onKeyDown={(e) => {
        if (!isNameKey(e.key, e.ctrlKey || e.metaKey)) e.preventDefault();
        onKeyDown?.(e);
      }}
      onChange={(e) => {
        const sanitized = sanitizePersonName(e.target.value);
        if (e.target.value !== sanitized) e.target.value = sanitized;
        onChange?.(e);
      }}
    />
  );
});

export default PersonNameField;
